import { useEffect } from "react";
import { userStore } from "entities/User/store/userStore";
import { useCompanySwitchStore } from "modules/CompanySwitch/store/useCompanySwitchStore";
import Dropdown from "components/Dropdown/Dropdown";
import { useAuthPersistedStore } from "shared/store";
import { useTranslation } from "react-i18next";
import "./CompanySwitch.Dropdown.styles.css";

const CompanySwitchDropdown = () => {
  const { t } = useTranslation("Shared");
  const isUserLocalAdmin = userStore((state) => state.isUserLocalAdmin);
  const selectedCompany = useCompanySwitchStore(
    (state) => state.selectedCompany
  );
  const setSelectedCompany = useCompanySwitchStore(
    (state) => state.setSelectedCompany
  );
  const companies = useCompanySwitchStore((state) => state.companies);
  const fetchCompanies = useCompanySwitchStore((state) => state.fetchCompanies);
  const isLoggedIn = useAuthPersistedStore((state) => state.isLoggedIn);

  const handleCompanySelect = (id) => {
    const company = companies.find((company) => company.id === id);
    setSelectedCompany(company);
  };
  useEffect(() => {
    if (!isUserLocalAdmin || !isLoggedIn) return;
    fetchCompanies();

    //eslint-disable-next-line
  }, [isUserLocalAdmin, isLoggedIn]);

  return (
    isUserLocalAdmin &&
    companies?.length > 0 &&
    selectedCompany && (
      <Dropdown
        id="company-switch_dropdown"
        options={companies?.map((company) => ({
          optionValue: company.id,
          displayValue: company.code,
        }))}
        label={t("labels.company")}
        selectedValue={selectedCompany.code}
        changeHandler={handleCompanySelect}
        minWidth={130}
        className="ms-3 d-flex align-items-center company-switch"
      />
    )
  );
};

export default CompanySwitchDropdown;
